<div class="distribution-lists-container">
  <div class="lists-panel">
    <div class="panel-header">
      <h3>Distribution Lists</h3>
      <button kendoButton themeColor="primary" (click)="createNew()">
        <span class="k-icon k-font-icon k-i-plus"></span> New List
      </button>
    </div>

    <kendo-grid
      [data]="lists"
      [loading]="loading"
      [selectable]="{ mode: 'single' }"
      (selectionChange)="onSelectionChange($event)"
      class="lists-grid"
    >
      <kendo-grid-column field="name" title="Name" [width]="160"></kendo-grid-column>
      <kendo-grid-column field="eventType" title="Event Type" [width]="130"></kendo-grid-column>
      <kendo-grid-column title="Members" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ getMemberCount(dataItem) }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="isActive" title="Active" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [class.active-badge]="dataItem.isActive" [class.inactive-badge]="!dataItem.isActive">
            {{ dataItem.isActive ? 'Yes' : 'No' }}
          </span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>

  <div class="list-details-panel" *ngIf="selectedList || isNew">
    <div class="panel-header">
      <h3>{{ isNew ? 'New Distribution List' : selectedList?.name }}</h3>
      <div class="header-actions" *ngIf="!isEditing">
        <button kendoButton (click)="editList()">
          <span class="k-icon k-font-icon k-i-edit"></span> Edit
        </button>
        <button kendoButton themeColor="error" (click)="deleteList()">
          <span class="k-icon k-font-icon k-i-delete"></span> Delete
        </button>
      </div>
    </div>

    <div *ngIf="!isEditing" class="list-view">
      <div class="info-section">
        <div class="info-row">
          <label>Event Type:</label>
          <span>{{ selectedList?.eventType }}</span>
        </div>
        <div class="info-row" *ngIf="selectedList?.description">
          <label>Description:</label>
          <span>{{ selectedList?.description }}</span>
        </div>
        <div class="info-row">
          <label>Status:</label>
          <span [class.active-badge]="selectedList?.isActive" [class.inactive-badge]="!selectedList?.isActive">
            {{ selectedList?.isActive ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </div>

      <div class="members-section">
        <div class="members-header">
          <h4>Members ({{ selectedList?.members?.length || 0 }})</h4>
          <button kendoButton size="small" themeColor="primary" (click)="openAddMemberDialog()">
            <span class="k-icon k-font-icon k-i-plus"></span> Add Member
          </button>
        </div>

        <kendo-grid
          [data]="selectedList?.members || []"
          class="members-grid"
        >
          <kendo-grid-column field="displayName" title="Name" [width]="160">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.displayName || '(No name)' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="email" title="Email"></kendo-grid-column>
          <kendo-grid-column field="isActive" title="Active" [width]="70">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [class.active-badge]="dataItem.isActive" [class.inactive-badge]="!dataItem.isActive">
                {{ dataItem.isActive ? 'Yes' : 'No' }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton size="small" fillMode="flat" themeColor="error" (click)="removeMember(dataItem)">
                <span class="k-icon k-font-icon k-i-delete"></span>
              </button>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>

    <form *ngIf="isEditing" [formGroup]="listForm" class="list-form">
      <div class="form-row">
        <label>Name *</label>
        <kendo-textbox formControlName="name" placeholder="Distribution list name"></kendo-textbox>
      </div>

      <div class="form-row">
        <label>Event Type *</label>
        <kendo-dropdownlist
          formControlName="eventType"
          [data]="eventTypes"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="form-row">
        <label>Description</label>
        <kendo-textarea formControlName="description" placeholder="Optional description" [rows]="3"></kendo-textarea>
      </div>

      <div class="form-row checkbox-row">
        <kendo-switch formControlName="isActive"></kendo-switch>
        <label>Active</label>
      </div>

      <div class="form-actions">
        <button kendoButton (click)="cancelEdit()" type="button">Cancel</button>
        <button kendoButton themeColor="primary" (click)="saveList()" [disabled]="listForm.invalid">
          {{ isNew ? 'Create' : 'Save' }}
        </button>
      </div>
    </form>
  </div>

  <div class="list-details-panel empty-state" *ngIf="!selectedList && !isNew">
    <div class="empty-message">
      <span class="k-icon k-font-icon k-i-user k-icon-xl"></span>
      <p>Select a distribution list from the panel or create a new one</p>
    </div>
  </div>
</div>

<!-- Add Member Dialog -->
<kendo-dialog
  *ngIf="showAddMemberDialog"
  title="Add Member"
  (close)="closeAddMemberDialog()"
  [width]="450"
>
  <form [formGroup]="memberForm">
    <div class="dialog-form-row">
      <label>Email Address *</label>
      <kendo-textbox formControlName="email" placeholder="email@example.com"></kendo-textbox>
    </div>
    <div class="dialog-form-row">
      <label>Display Name</label>
      <kendo-textbox formControlName="displayName" placeholder="Optional display name"></kendo-textbox>
    </div>
    <div class="dialog-form-row checkbox-row">
      <kendo-switch formControlName="isActive"></kendo-switch>
      <label>Active</label>
    </div>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeAddMemberDialog()">Cancel</button>
    <button kendoButton themeColor="primary" (click)="addMember()" [disabled]="memberForm.invalid">Add Member</button>
  </kendo-dialog-actions>
</kendo-dialog>